import { colors, font, IStyles } from 'theme'

export const defaultThemeStyles: IStyles = {
    background: colors.white,
    backgroundSub: colors.grey,
    darkBackground: colors.blackLight,
    lightBackground: colors.clouds,
    placeholder: colors.grey,
    border: colors.greyLight,
    borderContrast: colors.blackLight,
    borderActive: colors.darkCloud,
    textMain: colors.blackLight,
    textSub: colors.black,
    fontFamily: font.main,
    active: colors.black,
    disable: colors.grey,
    shadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
    panel: colors.white,
    error: colors.error,
    warning: colors.warning,
    online: colors.online,
    sleep: colors.sleep,
    offline: colors.offline,
    ping: colors.ping,
    displayOff: colors.displayOff,
    notSynchronized: colors.notSynchronized,
}
